import React from "react";
import moment from "moment";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import WbTwilightIcon from "@mui/icons-material/WbTwilight";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import { ORANGE, HEADER_HEIGHT } from "../constants";

export default function DayHeaderCell({ dayTs, isWeekly, isToday, isDayOff, counts }) {
  const dayMoment = moment(dayTs);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        height: HEADER_HEIGHT,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isDayOff
          ? "rgba(158,158,158,0.12)"
          : isToday
          ? `${ORANGE}12`
          : "var(--surface-card, #fff)",
        borderBottom: isToday ? `2px solid ${ORANGE}` : "2px solid rgba(0,0,0,0.1)",
        borderLeft: isToday ? `2px solid ${ORANGE}` : "none",
        borderRight: "1px solid rgba(0,0,0,0.04)",
        gap: 0.25,
        px: 0.25,
      }}
    >
      {/* Day name */}
      <Typography
        variant="caption"
        sx={{
          fontSize: isWeekly ? "0.6rem" : "0.55rem",
          fontWeight: 600,
          color: isToday ? ORANGE : isDayOff ? "text.disabled" : "text.secondary",
          textTransform: "capitalize",
          lineHeight: 1.2,
        }}
      >
        {dayMoment.format("ddd")}
      </Typography>

      {/* Day number */}
      <Typography
        variant="body2"
        sx={{
          fontSize: isWeekly ? "0.85rem" : "0.75rem",
          fontWeight: isToday ? 800 : 700,
          color: isToday ? ORANGE : isDayOff ? "text.disabled" : "text.primary",
          lineHeight: 1.1,
        }}
      >
        {dayMoment.format("D")}
      </Typography>

      {/* AM/PM/Night count badges */}
      {isWeekly && (counts.am > 0 || counts.pm > 0 || counts.night > 0) && (
        <Box
          sx={{
            display: "flex",
            gap: "1px",
            mt: 0.25,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {counts.am > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1px",
                backgroundColor: "rgba(76,175,80,0.15)",
                borderRadius: "3px",
                px: "2px",
                py: "1px",
              }}
            >
              <WbSunnyIcon sx={{ fontSize: 8, color: "#4caf50" }} />
              <Typography sx={{ fontSize: "0.5rem", fontWeight: 700, color: "#4caf50" }}>
                {counts.am}
              </Typography>
            </Box>
          )}
          {counts.pm > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1px",
                backgroundColor: `${ORANGE}20`,
                borderRadius: "3px",
                px: "2px",
                py: "1px",
              }}
            >
              <WbTwilightIcon sx={{ fontSize: 8, color: ORANGE }} />
              <Typography sx={{ fontSize: "0.5rem", fontWeight: 700, color: ORANGE }}>
                {counts.pm}
              </Typography>
            </Box>
          )}
          {counts.night > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1px",
                backgroundColor: "rgba(33,150,243,0.15)",
                borderRadius: "3px",
                px: "2px",
                py: "1px",
              }}
            >
              <NightsStayIcon sx={{ fontSize: 8, color: "#2196f3" }} />
              <Typography sx={{ fontSize: "0.5rem", fontWeight: 700, color: "#2196f3" }}>
                {counts.night}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {/* Monthly mode: compact count dots */}
      {!isWeekly && (counts.am > 0 || counts.pm > 0 || counts.night > 0) && (
        <Box sx={{ display: "flex", gap: "2px", mt: 0.25 }}>
          {counts.am > 0 && (
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#4caf50",
              }}
            />
          )}
          {counts.pm > 0 && (
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: ORANGE,
              }}
            />
          )}
          {counts.night > 0 && (
            <Box
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#2196f3",
              }}
            />
          )}
        </Box>
      )}
    </Box>
  );
}
